import bus from '../utilities/eventbus';

export default {
    props: {
      name: { type: String },
      required: { type: Boolean, default: false },
      label: { type: String, required: true },
      value: { type: [String, Number, Boolean], default: '' },
      id: { type: String, required: true },
      message: { type: String, required: false }, // Server-side validation message
      helpText: { type: String, default: '' },
      topHelpText: { type: String, default: '' },
      dataRequiredMessage: { type: String, default: null },
    },
    data() {
      return {
        touched: false,
        errors: [],
        internalModel: this.value || '',
      };
    },
    computed: {
      labelText() {
        return this.required ? `${this.label}*` : `${this.label}`;
      },
      requiredValidationMessage() {
        return this.dataRequiredMessage || `${this.label} is required`;
      },
    },
    methods: {
      onFocus() {
        bus.$emit('closeAllDropdown', null);
      },
      onBlur() {
        this.touched = true;
        if (this.$attrs.type !== 'file') {
          this.validate();
        }
      },
      validate() {
        this.errors = [];
        if (this.required && this.touched && this.internalModel === '') {
          this.errors.push(this.requiredValidationMessage);
        }
      },
    },
    mounted() {
      if (this.message) {
        this.errors.push(this.message);
      }
    },
  };
  